import OrganizationUserCreatePage from "@/features/organization/pages/OrganizationUserCreate";

const OrganizationUserCreate = () => {
  return <OrganizationUserCreatePage />;
};

export default OrganizationUserCreate;
